import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconIndent = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="15.628"
    height="12.279"
    viewBox="0 0 15.628 12.279"
    {...props}
  >
    <g transform="translate(0 -54.817)">
      <g transform="translate(0 54.817)">
        <path
          d="M15.348,383.722H.279a.268.268,0,0,0-.2.083A.268.268,0,0,0,0,384v1.674a.268.268,0,0,0,.083.2.268.268,0,0,0,.2.083H15.348a.283.283,0,0,0,.279-.279V384a.282.282,0,0,0-.279-.279Z"
          transform="translate(0 -373.676)"
        />
        <path
          d="M11.93,170.034a.283.283,0,0,0,.279-.279v-5.023a.283.283,0,0,0-.279-.279.271.271,0,0,0-.2.078l-2.512,2.512a.3.3,0,0,0,0,.4l2.512,2.512A.272.272,0,0,0,11.93,170.034Z"
          transform="translate(12.488 173.382) rotate(180)"
        />
        <path
          d="M192.492,164.453H183a.283.283,0,0,0-.279.279v1.674a.283.283,0,0,0,.279.279h9.488a.283.283,0,0,0,.279-.279v-1.674a.283.283,0,0,0-.279-.279Z"
          transform="translate(-177.144 -161.104)"
        />
        <path
          d="M192.492,274.082H183a.283.283,0,0,0-.279.279v1.674a.283.283,0,0,0,.279.279h9.488a.283.283,0,0,0,.279-.279v-1.674a.283.283,0,0,0-.279-.279Z"
          transform="translate(-177.144 -267.385)"
        />
        <path
          d="M15.545,54.9a.269.269,0,0,0-.2-.083H.279a.268.268,0,0,0-.2.083A.268.268,0,0,0,0,55.1V56.77a.268.268,0,0,0,.083.2.268.268,0,0,0,.2.083H15.348a.283.283,0,0,0,.279-.279V55.1A.269.269,0,0,0,15.545,54.9Z"
          transform="translate(0 -54.817)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconIndent)
